import { oauthClient } from "../apis/OAuthClient";
import { ApiPortalBackend } from "../apis/ApiPortalBackend";
import { PortalUser } from "../types/PortalUser";

class UserEventDispatcher extends EventTarget {
    static instance: UserEventDispatcher;
  
    constructor() {
      super();
      if (!UserEventDispatcher.instance) {
        UserEventDispatcher.instance = this;
      }
      return UserEventDispatcher.instance;
    }
  
    dispatchUserUpdateEvent() {
      const event = new Event('userUpdate');
      this.dispatchEvent(event);
    }
}

// Singleton Dispatcher
export const userEventDispatcher = new UserEventDispatcher();

export class UserService {
    private user: PortalUser | null = null;

    updateUser(newUser:PortalUser|null) {
        this.user = newUser;
        userEventDispatcher.dispatchUserUpdateEvent();
    }

    async forceFetchUser(): Promise<PortalUser | null> {
        let result = await ApiPortalBackend.GetMyself();
        if(!result) {
            this.updateUser(null);
            return this.user;
        }

        this.updateUser({
            user: {
                id: result.token.user.id, 
                userName: result.token.user.userName,
                displayName: result.token.user.displayName?result.token.user.displayName:result.token.user.userName,
            },
            token: {
                accessToken: result.token.accessToken,
                accessTokenExpiresAt: result.token.accessTokenExpiresAt
            }

        });

        return this.user;
      }
  
    async fetchUser(): Promise<PortalUser | null> {
      if (!this.user) {
        return await this.forceFetchUser();
      }
      return this.user;
    }
  
    getUser(): PortalUser | null {
      return this.user;
    }


    async isUserValid() {
        let valid = await oauthClient.checkTokenValidity();
        return valid;
    }
    
    async logoutUser () {
        this.updateUser(null);
        oauthClient.logout();
    }
  }
  
export const userService = new UserService();

